import { BaseLink } from "Components/Common/Base";
import { withPermission } from "Components/HOCs/withPermission";

export const NotesLink = withPermission(BaseLink, {
    module: "notes",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "notes",
    tooltipId: "notes-tooltip",
});

export const EmailLink = withPermission(BaseLink, {
    module: "emails",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "emails",
    tooltipId: "email-tooltip",
});

export const CallLink = withPermission(BaseLink, {
    module: "calls",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "calls",
    tooltipId: "call-tooltip",
});

export const TaskLink = withPermission(BaseLink, {
    module: "tasks",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "tasks",
    tooltipId: "tasks-tooltip",
});

export const MeetingLink = withPermission(BaseLink, {
    module: "meetings",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "meetings",
    tooltipId: "meetings-tooltip",
});

export const WhatsappLink = withPermission(BaseLink, {
    module: "whatsapp",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "create",
    featureKey: "whatsapp",
    tooltipId: "whatsapp-tooltip",
});
